<template>
  <div class="krs039">
    <!-- 일반사용자 홈 > 상단 -->
    <ProjectHeader />
    <!-- 일반사용자 홈 > 필터영역 -->
    <ProjectFilter ref="ProjectFilter" @addProject="addProject" />
    <modals-container
      @dialogConfirm="dialogConfirm"
      @dialogSubConfirm="dialogSubConfirm"
      @closeOkrLinkPopup="closeOkrLinkPopup"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ProjectHeader from "./ProjectHeader";
import ProjectFilter from "./ProjectFilter";
import EventBus from "@/js/eventbus/eventBus";
import MultiOrg from "@/components/cowork/common/organization/org/MultiOrg";
import CreateProject from "@/components/cowork/general/project/modal/CreateProject";
export default {
  components: {
    /* 일반사용자 홈 > 상단 영역 */
    ProjectHeader,
    /* 일반사용자 홈 > 필터 영역 */
    ProjectFilter,
  },
  mounted() {
    this.checkOrderList();
    this.checkOrgMapUse();
    this.checkPermissionUse();
     // 뒤로가기 이벤트 발생시 .
    const self = this;
    window.onpopstate = function (event) {
      let returnUrls = localStorage.getItem("returnUrls");
      if(returnUrls != null) {
        let urlList = returnUrls.split(",");
        if (urlList.length > 0) {
          if (urlList.length == 1) {
            localStorage.removeItem("returnUrls");
            // self.$router.push("/general/home");
          } else {
            urlList.pop();
            urlList.pop();
            localStorage.setItem("returnUrls", urlList);
            // this.$router.replace(urlList[urlList.length-1]);
          }
        } else {
          self.$router.push("/general/home");
        }
      }else{
          self.$router.push("/general/home");
      }
    }
  },
  data() {
    return {
      /* 추가에서 조직도 멤버추가시 그룹 아이디 */
      groupId: "",
      /* 토스트 팝업 정보 */
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
    };
  },
  created() {
    EventBus.$off("groupId");
    EventBus.$on("groupId", (groupId) => {
      this.groupId = groupId;
    });
  },
  methods: {
    ...mapActions("modals", ["showModal"]),
    ...mapActions("modals", ["showToast"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    /* 과체 추가 */
    addProject() {
      const modalInfo = {
        title: this.$i18nUtil.trans("title.CreateProject.001","과제 등록"),
        width: "800px",
        height: "743px",
        obj: this.$modal,
        listType: this.listType,
        component: CreateProject,
      };
      this.showModal(modalInfo);
    },
    dialogConfirm(dialogData) {
      // if (dialogData.dialogType == "addProjectMember") {
      //   console.log("dialogConfirm_addProjectMember");
      //   const modalInfo = {
      //     title: "조직도",
      //     method: "post",
      //     width: "1050px",
      //     height: "800px",
      //     obj: this.$modal,
      //     //orgType: "SINGLE_USER",
      //     //orgType: "MULTI_USER",
      //     orgType: "MULTI_ORG",
      //     //orgType: "SINGLE_DEPT",
      //     //orgType: "MULTI_DEPT",
      //     //component: Organization,
      //     component: MultiOrg,
      //     url: "/api/org/getDeptList",
      //   };
      //   this.showModal(modalInfo);
      //   EventBus.$emit("addProjectMember");
      // } else
      if (dialogData.dialogType == "OkrRegist") {
        console.log("dialogSubConfirm_OkrRegist");
        EventBus.$emit("OkrLinkRegistEvent", "cancel");
        this.$router.replace("/general/dashboard/" + dialogData.projectId);
      }
    },
    dialogSubConfirm(dialogData) {
      if (dialogData.dialogType == "OkrRegist") {
        console.log("dialogConfirm_OkrRegist");
        EventBus.$emit("OkrLinkRegistEvent", "confirm");
      }
    },
    /* 추가시 조직도 멤버 추가 */
    // registMember(data) {
    //   console.log("조직도 멤버추가", data);
    //   let obj = this;
    //   let type = data.orgType;
    //   let depts = data.depts;
    //   let users = data.users;
    //   if (depts.length > 0 || users.length > 0) {
    //     // if (depts.length > 0) {
    //     //   depts.forEach(function (item, index, arr) {
    //     //     params += item.label + ".";
    //     //   });
    //     // }
    //     if (users.length > 0) {
    //       let addCogroupUserList = [];
    //       users.forEach(function (item, index, arr) {
    //         //console.log("item:", item);
    //         let jsonData = {};
    //         jsonData.userId = item.userId;
    //         jsonData.userGrade = "MEMBER";
    //         jsonData.userKbn = "01";
    //         addCogroupUserList.push(jsonData);
    //       });
    //       const reqData = {
    //         url: "/api/cogroup/cogroupUser/registCogroupUser",
    //         method: "post",
    //         params: {
    //           groupId: obj.groupId,
    //           addCogroupUserList: addCogroupUserList,
    //         },
    //       };
    //       obj
    //         .COWORK_REST_SIMPLE_ACTION(reqData)
    //         .then((res) => {
    //           obj.toastInfo.message = obj.$i18nUtil.trans("TB064");
    //           obj.showToast(obj.toastInfo);
    //         })
    //         .catch((err) => {
    //           console.log(err);
    //           console.log("[멤버추가 오류]");
    //           alert("[멤버추가 오류]");
    //         });
    //     }
    //   }
    // },
    closeOkrLinkPopup() {
      this.$refs.ProjectFilter.getMyProjectList();
    },
       // 자동번호매기기 기능 사용 여부
       checkOrderList(){
      let obj = this;
      let reqData = {};
      let cdValue = true;
      reqData.params = {
        tenantId:obj.tenantId,
        cdCategory: "tenant.env",
        cdKey: "board.orderList.use",
      };
      reqData.url = "/api/org/code/checkCodeValue";
      reqData.method = "post";

      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            if(res.result.cdValue != undefined){
              cdValue = res.result.cdValue;
            }
            localStorage.setItem("orderListUse", cdValue);
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    // 보드에서 조직도로 멤버추가 기능 사용 여부
    checkOrgMapUse(){
      let obj = this;
      let reqData = {};
      let cdValue = false;
      reqData.params = {
        tenantId:obj.tenantId,
        cdCategory: "tenant.env",
        cdKey: "board.org.use",
      };
      reqData.url = "/api/org/code/checkCodeValue";
      reqData.method = "post";

      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            if(res.result.cdValue != undefined){
              cdValue = res.result.cdValue;
            }
            localStorage.setItem("orgMapUse", cdValue);
            //obj.orgMapUse = cdValue;
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
     // 보드에서 생성자 권한 이전 사용여부
     checkPermissionUse(){
      let obj = this;
      let reqData = {};
      let cdValue = false;
      reqData.params = {
        tenantId:obj.tenantId,
        cdCategory: "tenant.env",
        cdKey: "board.permission.use",
      };
      reqData.url = "/api/org/code/checkCodeValue";
      reqData.method = "post";

      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            if(res.result.cdValue != undefined){
              cdValue = res.result.cdValue;
            }
            localStorage.setItem("permissionUse", cdValue);
            //obj.permissionUse = cdValue;
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/cowork/general/project/base/Project.vue